<template >
  <div class="table-code-user">
    <!-- table-specific nao encontrei o css -->
    <table class="table specific tablecodeuser">
      <thead class="header-table">
        <tr>
          <th></th>
          <th>Nome</th>
        </tr>
      </thead>
      <tbody v-for="beneficioCodeUser in beneficiosCodeUser" :key="beneficioCodeUser.codeUser">
        <tr>
          <td style="width:100px">
            <b-button
              size="sm"
              @click.stop="openShowDetail(beneficioCodeUser)"
              @click="openCodeUser(beneficioCodeUser)"
              class="mr-2 button-open-close"
            >{{ beneficioCodeUser._showDetail ? '-' : '+'}}</b-button>
          </td>
          <td>{{beneficioCodeUser.nomeFuncionario}}</td>
        </tr>
        <tr v-if="beneficioCodeUser._showDetail">
          <td colspan="4">
            <div class="table-responsive">
              <table class="table-all">
                <thead class="header-table">
                  <tr>
                    <th scope="col" class="rigth-especific specific-th">Cod. Beneficio</th>
                    <th scope="col" class="rigth-especific specific-th">Beneficio</th>
                    <th scope="col" class="rigth-especific specific-th">Valor</th>
                    <th scope="col" class="rigth-especific specific-th">Valor Pago</th>
                  </tr>
                </thead>
                <tbody
                  v-for="beneficio in beneficioCodeUser.beneficiosCodeUsers"
                  :key="beneficio.id"
                >
                  <tr>
                    <td data-label="codigo do beneficio" class="rigth-especific specific-td">
                      {{beneficio.beneficioCodigo}}
                      <input class="mask-input-invisible-especific">
                    </td>
                    <td data-label="benefico" class="rigth-especific specific-td">
                      {{beneficio.beneficio}}
                      <div
                        class="margin-top-specific-reembolso"
                        style="color:red"
                        v-if="getImprimiValorPrevisto(beneficio)"
                      >PREVISÃO DE REEMBOLSO</div>
                    </td>
                    <td data-label="valor" class="rigth-especific specific-td">
                      <div>
                        <money
                          @blur.native="changevalue(beneficio)"
                          v-model="beneficio.valor"
                          v-bind="money"
                          class="mask-input rigth-especific"
                          :disabled="aprove || (beneficio.grupoCodigo == '02' && beneficio.beneficioCodigo == '03') || isAlreadyClosed"
                        ></money>
                      </div>
                      <div>
                        <div v-if="getImprimiValorPrevisto(beneficio)" style="color:red">
                          <money
                            v-model="beneficio.valuePermited"
                            v-bind="money"
                            class="mask-input-invisible-value-permited rigth-especific margin-top-specific"
                            :disabled="aprove"
                          ></money>
                        </div>
                      </div>
                    </td>
                    <td data-label="valor pago" class="rigth-especific specific-td">
                      <money
                        v-model="beneficio.valorPago"
                        v-bind="money"
                        class="mask-input-invisible-value-pay rigth-especific margin-top-specific"
                        disabled
                      ></money>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Money } from "v-money";
export default {
  name: "TableCodeUser",
  props: ["beneficiosCodeUser", "aprove", "isAlreadyClosed"],
  components: { Money },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    };
  },
  methods: {
    getImprimiValorPrevisto(beneficio) {
      return (
        ((beneficio.grupoCodigo == "10" ||
          beneficio.grupoCodigo == "17" ||
          beneficio.grupoCodigo == "18" ||
          beneficio.grupoCodigo == "19" ||
          beneficio.grupoCodigo == "20" ||
          beneficio.grupoCodigo == "21" ||
          (beneficio.grupoCodigo == "15" &&
            beneficio.beneficioCodigo != "02")) &&
          (beneficio.valuePermited != "" ||
            beneficio.valuePermited != 0 ||
            !beneficio.hasOwnProperty("valuePermited"))) ||
        (beneficio.grupoCodigo == "15" &&
          beneficio.beneficioCodigo != "02" &&
          beneficio.seeWhenPassInCheckValueAndZero &&
          (beneficio.valuePermited != "" ||
            beneficio.valuePermited == 0 ||
            !beneficio.hasOwnProperty("valuePermited"))) ||
        ((beneficio.grupoCodigo == "04" || beneficio.grupoCodigo == "05") &&
          (beneficio.beneficioCodigo == "01" ||
            beneficio.beneficioCodigo == "02") &&
          (beneficio.valuePermited != "" ||
            beneficio.valuePermited == 0 ||
            !beneficio.hasOwnProperty("valuePermited")))
      );
    },
    changevalue(beneficio) {
      this.$emit("listBeneficios", this.beneficiosCodeUser);
      this.$emit("getBeneficio", beneficio);
    },
    openShowDetail(beneficioCodeUser) {
      if (beneficioCodeUser._showDetail) beneficioCodeUser._showDetail = false;
      else beneficioCodeUser._showDetail = true;
    },
    openCodeUser(beneficioCodeUser) {
      this.$emit("openCodeUser", beneficioCodeUser);
    }
  }
};
</script>

<style scoped src="./table-code-user.css" ></style>
